// Period presets for reports, from the company's financial years.
export interface FY { label: string; starts_on: string; ends_on: string }
export const iso = (d: Date) => `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
const parse = (s: string) => new Date(s + "T00:00:00");

export function presets(years: FY[], today: string) {
  const t = parse(today);
  const cur = years.find((y) => y.starts_on <= today && today <= y.ends_on) ?? years.at(-1);
  const prev = cur ? years[years.indexOf(cur) - 1] : undefined;
  const m0 = new Date(t.getFullYear(), t.getMonth(), 1), m1 = new Date(t.getFullYear(), t.getMonth() + 1, 0);
  const l0 = new Date(t.getFullYear(), t.getMonth() - 1, 1), l1 = new Date(t.getFullYear(), t.getMonth(), 0);
  const q = Math.floor(t.getMonth() / 3) * 3;
  const out: { key: string; label: string; from: string; to: string }[] = [];
  if (cur) out.push({ key: "fy", label: `This year (${cur.label})`, from: cur.starts_on, to: cur.ends_on });
  if (prev) out.push({ key: "lfy", label: `Last year (${prev.label})`, from: prev.starts_on, to: prev.ends_on });
  out.push({ key: "m", label: "This month", from: iso(m0), to: iso(m1) });
  out.push({ key: "lm", label: "Last month", from: iso(l0), to: iso(l1) });
  out.push({ key: "q", label: "This quarter", from: iso(new Date(t.getFullYear(), q, 1)), to: iso(new Date(t.getFullYear(), q + 3, 0)) });
  return out;
}

// the tax year (Income-tax Act, 2025: April–March) a date falls in, by its starting year
export const taxYearOf = (d: string) => { const x = parse(d); return x.getMonth() < 3 ? x.getFullYear() - 1 : x.getFullYear(); };
export const quarterOf = (d: string) => { const m = parse(d).getMonth(); return m < 3 ? 4 : Math.floor((m - 3) / 3) + 1; };

export function toCsv(cols: { key: string; label: string }[], rows: Record<string, unknown>[]): string {
  const esc = (v: unknown) => { const s = v == null ? "" : String(v); return /[",\n]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s; };
  return [cols.map((c) => esc(c.label || c.key)).join(","), ...rows.map((r) => cols.map((c) => esc(r[c.key])).join(","))].join("\n");
}
